import { render, staticRenderFns } from "./SampleOrder.vue?vue&type=template&id=fd7873bc&scoped=true"
import script from "./SampleOrder.vue?vue&type=script&lang=ts"
export * from "./SampleOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7873bc",
  null
  
)

export default component.exports